import AssessmentIcon from '@mui/icons-material/Assessment';
import CodeIcon from "@mui/icons-material/Code";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import DevicesIcon from '@mui/icons-material/Devices';
import SpeedIcon from '@mui/icons-material/Speed';
import StorageIcon from '@mui/icons-material/Storage';
import BrushIcon from '@mui/icons-material/Brush';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SearchIcon from '@mui/icons-material/Search';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import LayersIcon from '@mui/icons-material/Layers';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';

export const exploreServiceData = {
  "OnPageSeo": {
    hero: {
      title: "On-Page SEO Services",
      subtitle: "On-Page SEO Services to Boost Rankings, Traffic, and Conversions",
      description: "Our On-Page SEO Services improve your website content, structure, and performance using effective On-Page SEO Optimization and proven Technical On-Page SEO Techniques to drive higher rankings and targeted organic traffic.",
      badgeText: "Trusted by 200+ businesses",
      stats: [
        { value: "1000+", label: "Pages Optimized" },
        { value: "98%", label: "Satisfaction Rate" },
        { value: "6x", label: "Traffic Growth" },
        { value: "Top 3", label: "Google Ranking" }
      ]
    },
    services: {
      title: "Complete On-Page SEO Services for Maximum Website Performance",
      description: "We provide end-to-end On-Page SEO Services designed to improve rankings, user experience, and website authority.",
      list: [
        {
          title: "On-Page SEO Audit & Analysis",
          icon: AssessmentIcon,
          desc: "We perform a detailed audit to identify SEO issues, keyword gaps, and technical errors using advanced Technical On-Page SEO Techniques.",
          features: ["SEO Issues ID", "Keyword Gaps", "Technical Errors"]
        },
        {
          title: "Content & Keyword Optimization",
          icon: CodeIcon,
          desc: "We optimize headings, meta tags, and content using effective On-Page SEO Optimization to improve keyword relevance and rankings.",
          features: ["Headings & Meta Tags", "Content Quality", "Keyword Density"]
        },
        {
          title: "Technical On-Page SEO Improvements",
          icon: SettingsSuggestIcon,
          desc: "We enhance speed, URL structure, schema, and internal linking to meet all Technical On-Page SEO Techniques standards.",
          features: ["Site Speed", "Schema Markup", "Internal Linking"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Proven On-Page SEO Optimization Process",
      steps: [
        { title: "Website SEO Analysis", desc: "We analyze your website structure, content, and current performance." },
        { title: "On-Page SEO Audit", desc: "We identify issues using data-driven Technical On-Page SEO Techniques." },
        { title: "Implementation & Optimization", desc: "We apply complete On-Page SEO Optimization including content and technical fixes." },
        { title: "Monitoring & Improvement", desc: "We track results and continuously improve rankings and traffic." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best On-Page SEO Services for Sustainable Growth",
      reasons: [
        { title: "Experienced SEO Experts", desc: "We deliver result-driven On-Page SEO Services across industries." },
        { title: "Data-Driven Strategy", desc: "We use analytics to implement effective On-Page SEO Optimization." },
        { title: "Customized SEO Solutions", desc: "Strategies are tailored to your business and audience." },
        { title: "Advanced Technical Expertise", desc: "We apply the latest Technical On-Page SEO Techniques for better rankings." }
      ],
      stats: [
        { value: "6x", label: "Average Traffic Growth" },
        { value: "98%", label: "Client Satisfaction" },
        { value: "1000+", label: "Pages Optimized" },
        { value: "Top 3", label: "Ranking Achieved" }
      ]
    },
    results: {
      subtitle: "◆ On-Page SEO Services",
      title: "Measurable SEO Results That Drive Growth",
      items: [
        {
          title: "Higher Keyword Rankings",
          desc: "Improved positions with structured On-Page SEO Optimization.",
          metrics: [
            { value: "Top 3", label: "Rankings" },
            { value: "6x", label: "Growth" }
          ],
          color: "#2563eb"
        },
        {
          title: "Increased Organic Traffic",
          desc: "More visitors through optimized On-Page SEO Services.",
          metrics: [
            { value: "4x", label: "Traffic Growth" },
            { value: "60 Days", label: "Average Results" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Improved Website Performance",
          desc: "Better speed and usability using Technical On-Page SEO Techniques.",
          metrics: [
            { value: "90+", label: "Page Speed Score" },
            { value: "Higher", label: "Engagement" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Rank Higher with On-Page SEO Services?",
      description: "Start with expert On-Page SEO Services, powerful On-Page SEO Optimization, and proven Technical On-Page SEO Techniques to grow your traffic and rankings.",
      cta: "Contact Us ↗"
    }
  },
  "OffPageSeo": {
    hero: {
      title: "OFF-Page SEO Services",
      subtitle: "OFF-Page SEO Services to Boost Authority and Rankings",
      description: "Our expert OFF-Page SEO Services help your website gain credibility, authority, and higher rankings on search engines. We implement advanced off-page seo optimization strategies and proven off page SEO techniques like link building, brand mentions, and outreach to improve your online presence and drive organic growth.",
      badgeText: "High Authority Backlinking",
      stats: [
        { value: "1200+", label: "Websites Optimized" },
        { value: "98%", label: "Client Satisfaction Rate" },
        { value: "4x", label: "Increase in Domain Authority" },
        { value: "Top 5", label: "Ranking Achieved" }
      ]
    },
    services: {
      title: "Comprehensive OFF-Page SEO Services for Strong Online Authority",
      description: "We deliver result-driven OFF-Page SEO Services to improve your website’s trust, authority, and search engine rankings.",
      list: [
        {
          title: "High-Quality Link Building",
          icon: AssessmentIcon,
          desc: "We build authoritative backlinks using ethical off page SEO techniques to increase your domain authority and credibility.",
          features: ["Auth Backlinks", "Ethical SEO", "Trust Building"]
        },
        {
          title: "OFF-Page SEO Optimization",
          icon: SettingsSuggestIcon,
          desc: "Our strategies focus on guest posting, outreach, and brand mentions to strengthen your website’s off-page signals.",
          features: ["Guest Posting", "Brand Mentions", "Outreach"]
        },
        {
          title: "Brand Mentions & Social Signals",
          icon: CodeIcon,
          desc: "We enhance your brand visibility through social media engagement, citations, and external mentions to boost SEO performance.",
          features: ["Brand Visibility", "Social Engagement", "Performance Boost"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our OFF-Page SEO Services Process",
      steps: [
        { title: "01 – Competitor Analysis", desc: "We analyze competitors’ backlink profiles and strategies." },
        { title: "02 – Strategy Planning", desc: "We create a customized off-page seo optimization plan tailored to your business." },
        { title: "03 – Implementation", desc: "We execute link building and outreach using effective off page SEO techniques." },
        { title: "04 – Monitoring & Reporting", desc: "We track backlinks, domain authority, and ranking improvements." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best OFF-Page SEO Services for Authority Building",
      reasons: [
        { title: "SEO Experts", desc: "Our team specializes in advanced OFF-Page SEO Services for all industries." },
        { title: "White-Hat Techniques", desc: "We use safe and proven off page SEO techniques to ensure long-term success." },
        { title: "Customized Strategy", desc: "Every campaign is tailored with the right off-page seo optimization methods." },
        { title: "Transparent Reporting", desc: "We provide clear insights into backlinks and performance growth." }
      ],
      stats: [
        { value: "4x", label: "DA Increase" },
        { value: "98%", label: "Satisfaction Rate" },
        { value: "100%", label: "Safe Links" },
        { value: "Top 5", label: "Ranking Achieved" }
      ]
    },
    results: {
      subtitle: "◆ OFF-Page SEO Services",
      title: "Measurable SEO Growth & Authority",
      items: [
        {
          title: "Improved Domain Authority",
          desc: "Build strong backlinks with effective OFF-Page SEO Services.",
          metrics: [
            { value: "90+", label: "DA" },
            { value: "Strong", label: "Authority" },
            { value: "High Quality", label: "Links" },
            { value: "Trusted", label: "Sources" }
          ],
          color: "#2563eb"
        },
        {
          title: "Better Online Visibility",
          desc: "Boost brand presence through off-page seo optimization.",
          metrics: [
            { value: "More", label: "Mentions" },
            { value: "Brand", label: "Reach" },
            { value: "Higher", label: "Engagement" },
            { value: "Social", label: "Signals" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Higher Search Rankings",
          desc: "Strong off-page signals improve rankings and traffic.",
          metrics: [
            { value: "Top", label: "Rankings" },
            { value: "Keyword", label: "Positions" },
            { value: "Increased", label: "Traffic" },
            { value: "Organic", label: "Growth" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Grow with OFF-Page SEO Services?",
      description: "Boost your rankings with expert OFF-Page SEO Services, advanced off-page seo optimization, and proven off page SEO techniques to build authority and drive organic traffic.",
      cta: "Contact Us ↗"
    }
  },
  "KeywordResearchServices": {
    hero: {
      title: "Keyword Research Services",
      subtitle: "Keyword Research Services to Target the Right Audience and Boost Rankings",
      description: "Our expert Keyword Research Services help you find high-impact keywords that drive traffic and conversions. We use advanced SEO Keyword Analysis and build a powerful Keyword Research Strategy to target the right audience and improve search rankings.",
      badgeText: "High Intent Targeting",
      stats: [
        { value: "1500+", label: "Keywords Researched" },
        { value: "96%", label: "Satisfaction Rate" },
        { value: "5x", label: "Traffic Growth" },
        { value: "Top 3", label: "Google Rankings" }
      ]
    },
    services: {
      title: "Complete Keyword Research Services for Better Search Visibility",
      description: "We provide end-to-end Keyword Research Services to help your business rank for the most relevant and high-converting keywords.",
      list: [
        {
          title: "SEO Keyword Analysis",
          icon: QueryStatsIcon,
          desc: "We perform in-depth SEO Keyword Analysis to identify search intent, keyword difficulty, and ranking opportunities.",
          features: ["Search Intent", "Difficulty Score", "Ranking Potential"]
        },
        {
          title: "Keyword Research Strategy",
          icon: SettingsSuggestIcon,
          desc: "We build a customized Keyword Research Strategy based on your business goals, audience, and competition.",
          features: ["Goal Alignment", "Audience Targeting", "Gap Analysis"]
        },
        {
          title: "Competitor Keyword Research",
          icon: TravelExploreIcon,
          desc: "We analyze competitor keywords to discover gaps and opportunities that can give you a competitive advantage.",
          features: ["Gap Analysis", "Market Share", "Competitor Intel"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Keyword Research Strategy Process",
      steps: [
        { title: "Business & Audience Analysis", desc: "We understand your target audience, niche, and business goals." },
        { title: "SEO Keyword Analysis", desc: "We identify high-volume, low-competition keywords using advanced tools." },
        { title: "Strategy Development", desc: "We create a data-driven Keyword Research Strategy aligned with your goals." },
        { title: "Implementation & Tracking", desc: "We map keywords to pages and monitor performance for continuous improvement." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best Keyword Research Services for Targeted Growth",
      reasons: [
        { title: "Experienced SEO Specialists", desc: "We deliver result-oriented Keyword Research Services for different industries." },
        { title: "Data-Driven Keyword Insights", desc: "Our SEO Keyword Analysis is backed by real-time data and tools." },
        { title: "Customized Keyword Strategy", desc: "We create a unique Keyword Research Strategy tailored to your business." },
        { title: "Competitive Advantage", desc: "We help you target keywords your competitors are missing." }
      ],
      stats: [
        { value: "5x", label: "Traffic Growth" },
        { value: "96%", label: "Satisfaction Rate" },
        { value: "1500+", label: "Keywords Found" },
        { value: "Top 3", label: "Keyword Rankings" }
      ]
    },
    results: {
      subtitle: "◆ Keyword Research Services",
      title: "Measurable Results from Smart Keyword Targeting",
      items: [
        {
          title: "Higher Keyword Rankings",
          desc: "Rank for relevant keywords using a strong Keyword Research Strategy.",
          metrics: [
            { value: "Top 3", label: "Rankings" },
            { value: "5x", label: "Visibility" }
          ],
          color: "#2563eb"
        },
        {
          title: "Increased Organic Traffic",
          desc: "Drive more visitors through effective Keyword Research Services.",
          metrics: [
            { value: "4x", label: "Traffic Growth" },
            { value: "60 Days", label: "Average Results" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Better Conversion Rates",
          desc: "Target the right audience with precise SEO Keyword Analysis.",
          metrics: [
            { value: "High Intent", label: "Traffic" },
            { value: "Better", label: "ROI" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Grow with Keyword Research Services?",
      description: "Start with expert Keyword Research Services, detailed SEO Keyword Analysis, and a powerful Keyword Research Strategy to boost your rankings and traffic.",
      cta: "Contact Us ↗"
    }
  },
  "SeoConsultanting": {
    hero: {
      title: "SEO Consultant Services",
      subtitle: "SEO Consultant Services to Build a Winning Growth Strategy",
      description: "Our professional SEO Consultant Services help businesses improve rankings, traffic, and conversions with data-driven strategies. As a trusted SEO Consulting Company, we provide expert guidance and SEO Expert Services to create scalable and long-term SEO success.",
      badgeText: "Expert Strategic Guidance",
      stats: [
        { value: "500+", label: "Strategies Delivered" },
        { value: "95%", label: "Satisfaction Rate" },
        { value: "6x", label: "Average Growth" },
        { value: "Top 5", label: "Google Positions" }
      ]
    },
    services: {
      title: "Complete SEO Consultant Services for Business Growth",
      description: "We provide end-to-end SEO Consultant Services to help businesses build strong SEO strategies and achieve sustainable growth.",
      list: [
        {
          title: "SEO Audit & Analysis",
          icon: AssessmentIcon,
          desc: "We perform a detailed audit to identify issues, opportunities, and gaps using advanced SEO Expert Services.",
          features: ["Deep Audit", "Gap Analysis", "Expert Insights"]
        },
        {
          title: "Custom SEO Strategy",
          icon: SettingsSuggestIcon,
          desc: "As a leading SEO Consulting Company, we create tailored SEO strategies based on your business goals and target audience.",
          features: ["Tailored Roadmaps", "Audience Focused", "Scalable Growth"]
        },
        {
          title: "Competitor & Market Analysis",
          icon: TravelExploreIcon,
          desc: "We analyze your competitors to identify winning strategies and help you stay ahead in search rankings.",
          features: ["Market Intel", "Competitor Gaps", "Wining Tactics"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our SEO Consulting Process",
      steps: [
        { title: "Discovery & Goal Setting", desc: "We understand your business objectives, target audience, and challenges." },
        { title: "SEO Audit & Insights", desc: "We conduct a complete audit using professional SEO Expert Services to identify key opportunities." },
        { title: "Strategy Development", desc: "We build a data-driven plan as a trusted SEO Consulting Company." },
        { title: "Monitoring & Optimization", desc: "We track performance and continuously refine strategies for better results." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best SEO Consultant Services for Long-Term Results",
      reasons: [
        { title: "Experienced SEO Experts", desc: "Our team delivers high-quality SEO Expert Services across industries." },
        { title: "Data-Driven Approach", desc: "We use analytics and tools to implement effective SEO Consultant Services." },
        { title: "Customized SEO Strategies", desc: "We create strategies tailored to your business needs and goals." },
        { title: "Trusted SEO Consulting Company", desc: "We provide reliable and result-oriented consulting services for long-term growth." }
      ],
      stats: [
        { value: "6x", label: "Growth Achieved" },
        { value: "95%", label: "Satisfaction Rate" },
        { value: "500+", label: "Success Plans" },
        { value: "Top 5", label: "Keyword Rankings" }
      ]
    },
    results: {
      subtitle: "◆ SEO Consultant Services",
      title: "Measurable SEO Results That Drive Business Growth",
      items: [
        {
          title: "Higher Search Rankings",
          desc: "Improved keyword positions with expert SEO Consultant Services.",
          metrics: [
            { value: "Top 3", label: "Rankings" },
            { value: "6x", label: "Visibility" }
          ],
          color: "#2563eb"
        },
        {
          title: "Increased Organic Traffic",
          desc: "Drive more visitors through strategic SEO Expert Services.",
          metrics: [
            { value: "4x", label: "Traffic Growth" },
            { value: "90 Days", label: "Results Timeline" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Sustainable Business Growth",
          desc: "Long-term growth with guidance from a trusted SEO Consulting Company.",
          metrics: [
            { value: "Higher", label: "ROI" },
            { value: "Consistent", label: "Growth" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Grow with SEO Consultant Services?",
      description: "Start with expert SEO Consultant Services, trusted SEO Expert Services, and a reliable SEO Consulting Company to boost your rankings, traffic, and business growth.",
      cta: "Contact Us ↗"
    }
  },
  "SEO Consulting Services": {
    hero: {
      title: "SEO Consulting Services",
      subtitle: "SEO Consulting Services to Build a Winning Growth Strategy",
      description: "Our professional SEO Consulting Services help businesses improve rankings, traffic, and conversions with data-driven strategies. As a trusted SEO Consulting Company, we provide expert guidance and SEO Expert Services to create scalable and long-term SEO success.",
      badgeText: "Expert Strategic Guidance",
      stats: [
        { value: "500+", label: "Strategies Delivered" },
        { value: "95%", label: "Satisfaction Rate" },
        { value: "6x", label: "Average Growth" },
        { value: "Top 5", label: "Google Positions" }
      ]
    },
    services: {
      title: "Complete SEO Consulting Services for Business Growth",
      description: "We provide end-to-end SEO Consulting Services to help businesses build strong SEO strategies and achieve sustainable growth.",
      list: [
        {
          title: "SEO Audit & Analysis",
          icon: AssessmentIcon,
          desc: "We perform a detailed audit to identify issues, opportunities, and gaps using advanced SEO Expert Services.",
          features: ["Deep Audit", "Gap Analysis", "Expert Insights"]
        },
        {
          title: "Custom SEO Strategy",
          icon: SettingsSuggestIcon,
          desc: "As a leading SEO Consulting Company, we create tailored SEO strategies based on your business goals and target audience.",
          features: ["Tailored Roadmaps", "Audience Focused", "Scalable Growth"]
        },
        {
          title: "Competitor & Market Analysis",
          icon: TravelExploreIcon,
          desc: "We analyze your competitors to identify winning strategies and help you stay ahead in search rankings.",
          features: ["Market Intel", "Competitor Gaps", "Wining Tactics"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our SEO Consulting Process",
      steps: [
        { title: "Discovery & Goal Setting", desc: "We understand your business objectives, target audience, and challenges." },
        { title: "SEO Audit & Insights", desc: "We conduct a complete audit using professional SEO Expert Services to identify key opportunities." },
        { title: "Strategy Development", desc: "We build a data-driven plan as a trusted SEO Consulting Company." },
        { title: "Monitoring & Optimization", desc: "We track performance and continuously refine strategies for better results." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best SEO Consulting Services for Long-Term Results",
      reasons: [
        { title: "Experienced SEO Experts", desc: "Our team delivers high-quality SEO Expert Services across industries." },
        { title: "Data-Driven Approach", desc: "We use analytics and tools to implement effective SEO Consulting Services." },
        { title: "Customized SEO Strategies", desc: "We create strategies tailored to your business needs and goals." },
        { title: "Trusted SEO Consulting Company", desc: "We provide reliable and result-oriented consulting services for long-term growth." }
      ],
      stats: [
        { value: "6x", label: "Growth Achieved" },
        { value: "95%", label: "Satisfaction Rate" },
        { value: "500+", label: "Success Plans" },
        { value: "Top 5", label: "Keyword Rankings" }
      ]
    },
    results: {
      subtitle: "◆ SEO Consulting Services",
      title: "Measurable SEO Results That Drive Business Growth",
      items: [
        {
          title: "Higher Search Rankings",
          desc: "Improved keyword positions with expert SEO Consulting Services.",
          metrics: [
            { value: "Top 3", label: "Rankings" },
            { value: "6x", label: "Visibility" }
          ],
          color: "#2563eb"
        },
        {
          title: "Increased Organic Traffic",
          desc: "Drive more visitors through strategic SEO Expert Services.",
          metrics: [
            { value: "4x", label: "Traffic Growth" },
            { value: "90 Days", label: "Results Timeline" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Sustainable Business Growth",
          desc: "Long-term growth with guidance from a trusted SEO Consulting Company.",
          metrics: [
            { value: "Higher", label: "ROI" },
            { value: "Consistent", label: "Growth" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Grow with SEO Consulting Services?",
      description: "Start with expert SEO Consulting Services, trusted SEO Expert Services, and a reliable SEO Consulting Company to boost your rankings, traffic, and business growth.",
      cta: "Contact Us ↗"
    }
  },
  "WebsiteDesignServices": {
    hero: {
      title: "Website Design Services",
      subtitle: "Website Design Services to Create Modern, High-Converting Websites",
      description: "Our expert Website Design Services help businesses build visually appealing, user-friendly, and conversion-focused websites. As a Professional Website Design Company, we deliver Custom Web Design Services tailored to your brand and business goals.",
      badgeText: "Creative Design Excellence",
      stats: [
        { value: "800+", label: "Websites Designed" },
        { value: "97%", label: "Satisfaction Rate" },
        { value: "4x", label: "Conversion Lift" },
        { value: "100%", label: "Responsive Design" }
      ]
    },
    services: {
      title: "Complete Website Design Services for Business Growth",
      description: "We provide end-to-end Website Design Services to create websites that are visually engaging and performance-driven.",
      list: [
        {
          title: "Custom Web Design Services",
          icon: BrushIcon,
          desc: "We create unique and brand-focused websites through our Custom Web Design Services, ensuring your business stands out online.",
          features: ["Unique Branding", "Custom Layouts", "Brand Identity"]
        },
        {
          title: "Responsive Website Design",
          icon: DevicesIcon,
          desc: "As a Professional Website Design Company, we design fully responsive websites that work seamlessly across all devices.",
          features: ["Mobile First", "Cross-Browser", "Adaptive Layouts"]
        },
        {
          title: "UI/UX Design Optimization",
          icon: ViewQuiltIcon,
          desc: "We focus on user experience, layout, and navigation to improve engagement and conversions.",
          features: ["User Journeys", "Intelligent UX", "Conversion Paths"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Website Design Process",
      steps: [
        { title: "Requirement Analysis", desc: "We understand your business goals, audience, and design preferences." },
        { title: "Design Planning", desc: "We create wireframes and layouts as part of our Custom Web Design Services." },
        { title: "Development & Design", desc: "We build and design your website as a Professional Website Design Company." },
        { title: "Testing & Launch", desc: "We test performance, responsiveness, and usability before launch." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best Website Design Services for Modern Businesses",
      reasons: [
        { title: "Creative Design Experts", desc: "Our team delivers visually stunning Website Design Services tailored to your brand." },
        { title: "User-Centric Approach", desc: "We focus on user experience to improve engagement and conversions." },
        { title: "Customized Design Solutions", desc: "We offer fully Custom Web Design Services based on your business needs." },
        { title: "Trusted Design Company", desc: "We are a reliable Professional Website Design Company delivering quality results." }
      ],
      stats: [
        { value: "4x", label: "Conversion Lift" },
        { value: "97%", label: "Satisfaction Rate" },
        { value: "800+", label: "Success Stories" },
        { value: "100%", label: "Responsive Rate" }
      ]
    },
    results: {
      subtitle: "◆ Website Design Services",
      title: "Results That Improve User Experience and Conversions",
      items: [
        {
          title: "Modern & Responsive Design",
          desc: "We create websites that look great on all devices with our Website Design Services.",
          metrics: [
            { value: "100%", label: "Responsive" },
            { value: "Better", label: "UX" }
          ],
          color: "#2563eb"
        },
        {
          title: "Higher Conversion Rates",
          desc: "Optimized layouts improve conversions using Custom Web Design Services.",
          metrics: [
            { value: "4x", label: "Conversions" },
            { value: "Better", label: "Engagement" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Strong Brand Presence",
          desc: "Build a powerful online identity with a Professional Website Design Company.",
          metrics: [
            { value: "Unique", label: "Design" },
            { value: "Business", label: "Growth" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Build Your Website with Website Design Services?",
      description: "Start with expert Website Design Services, creative Custom Web Design Services, and a trusted Professional Website Design Company to grow your business online.",
      cta: "Contact Us ↗"
    }
  },
  "FrontendDevelopmentServices": {
    hero: {
      title: "Frontend Development Services",
      subtitle: "Frontend Development Services to Build Fast, Responsive, and Engaging Interfaces",
      description: "Our expert Frontend Development Services help you create modern, interactive, and high-performance user interfaces. As a trusted Front End Web Development Company, we deliver Responsive Frontend Development solutions that ensure seamless experiences across all devices.",
      badgeText: "Pixel Perfect Interfaces",
      stats: [
        { value: "900+", label: "Projects Delivered" },
        { value: "96%", label: "Satisfaction Rate" },
        { value: "3x", label: "Speed Gain" },
        { value: "100%", label: "Responsive Rate" }
      ]
    },
    services: {
      title: "Complete Frontend Development Services for Modern Applications",
      description: "We provide end-to-end Frontend Development Services to build visually appealing and high-performing user interfaces.",
      list: [
        {
          title: "Responsive Frontend Development",
          icon: DevicesIcon,
          desc: "We create fully Responsive Frontend Development solutions that adapt seamlessly to mobile, tablet, and desktop devices.",
          features: ["Mobile First", "Fluid Grids", "Breakpoints Control"]
        },
        {
          title: "UI Development & Optimization",
          icon: CodeIcon,
          desc: "As a leading Front End Web Development Company, we build user-friendly interfaces with clean code and optimized performance.",
          features: ["Clean Code", "Optimized Assets", "Fast Rendering"]
        },
        {
          title: "Framework-Based Development",
          icon: LayersIcon,
          desc: "We use modern frameworks like React, Angular, and Vue to deliver scalable and efficient frontend applications.",
          features: ["React/Next.js", "Vue/Nuxt.js", "Angular/Svelte"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Frontend Development Process",
      steps: [
        { title: "Requirement Analysis", desc: "We understand your design, functionality, and user experience goals." },
        { title: "UI/UX Planning", desc: "We create layouts and wireframes for effective Responsive Frontend Development." },
        { title: "Development & Integration", desc: "We build your interface as a professional Front End Web Development Company." },
        { title: "Testing & Optimization", desc: "We ensure performance, responsiveness, and cross-browser compatibility." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best Frontend Development Services for High Performance",
      reasons: [
        { title: "Expert Frontend Developers", desc: "Our team delivers high-quality Frontend Development Services using modern technologies." },
        { title: "Performance-Focused", desc: "We ensure fast-loading and optimized interfaces." },
        { title: "Responsive Design Expertise", desc: "We specialize in Responsive Frontend Development for all devices." },
        { title: "Trusted Development Company", desc: "We are a reliable Front End Web Development Company delivering scalable solutions." }
      ],
      stats: [
        { value: "3x", label: "Speed Gain" },
        { value: "96%", label: "Satisfaction Rate" },
        { value: "900+", label: "Interfaces Built" },
        { value: "100%", label: "Responsive Success" }
      ]
    },
    results: {
      subtitle: "◆ Frontend Development Services",
      title: "Results That Improve User Experience and Performance",
      items: [
        {
          title: "Fast & Responsive Interfaces",
          desc: "We build high-speed interfaces with Responsive Frontend Development.",
          metrics: [
            { value: "100%", label: "Responsive" },
            { value: "Faster", label: "Load Time" }
          ],
          color: "#2563eb"
        },
        {
          title: "Improved User Engagement",
          desc: "Interactive designs improve user interaction through Frontend Development Services.",
          metrics: [
            { value: "Higher", label: "Engagement" },
            { value: "Better", label: "Retention" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Modern UI Experience",
          desc: "We deliver advanced UI solutions as a Front End Web Development Company.",
          metrics: [
            { value: "Clean", label: "Design" },
            { value: "Scalable", label: "Code" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Build with Frontend Development Services?",
      description: "Start with expert Frontend Development Services, scalable Responsive Frontend Development, and a trusted Front End Web Development Company to create high-performing web interfaces.",
      cta: "Contact Us ↗"
    }
  },
  "BackendDevelopmentServices": {
    hero: {
      title: "Backend Development Services",
      subtitle: "Backend Development Services to Build Secure, Scalable, and High-Performance Systems",
      description: "Our expert Backend Development Services help businesses build robust and secure server-side applications. Whether you want to Hire Backend Developer or need reliable Server Side Development Services, we deliver scalable solutions that power your applications.",
      badgeText: "Robust System Architecture",
      stats: [
        { value: "850+", label: "Backend delivered" },
        { value: "97%", label: "Satisfaction Rate" },
        { value: "4x", label: "Speed Gain" },
        { value: "99.9%", label: "System Uptime" }
      ]
    },
    services: {
      title: "Complete Backend Development Services for Scalable Applications",
      description: "We provide end-to-end Backend Development Services to build secure, efficient, and scalable server-side systems.",
      list: [
        {
          title: "Custom Backend Development",
          icon: StorageIcon,
          desc: "We design and develop tailored backend systems to meet your business requirements with high performance and scalability.",
          features: ["Tailored Logic", "Secure Data", "Scalable Growth"]
        },
        {
          title: "Hire Backend Developer",
          icon: SupportAgentIcon,
          desc: "Looking to Hire Backend Developer? Our experienced developers work with modern technologies like Node.js, Java, and Python.",
          features: ["Expert Devs", "Modern Stacks", "Rapid Delivery"]
        },
        {
          title: "Server Side Development Services",
          icon: SettingsSuggestIcon,
          desc: "We deliver reliable Server Side Development Services including API development, database management, and system integration.",
          features: ["API Dev", "DB Management", "Integrations"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Backend Development Process",
      steps: [
        { title: "Requirement Analysis", desc: "We understand your business logic, system requirements, and goals." },
        { title: "System Architecture Design", desc: "We design a scalable architecture for efficient Server Side Development Services." },
        { title: "Development & Integration", our: "Our team builds secure systems as part of our Backend Development Services." },
        { title: "Testing & Deployment", desc: "We ensure performance, security, and reliability before deployment." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best Backend Development Services for High Performance",
      reasons: [
        { title: "Experienced Backend Developers", desc: "Our team provides expert Backend Development Services for various industries." },
        { title: "Scalable & Secure Solutions", desc: "We build systems that handle high traffic with strong security." },
        { title: "Flexible Hiring Model", desc: "You can easily Hire Backend Developer based on your project needs." },
        { title: "Advanced Technical Expertise", desc: "We deliver reliable Server Side Development Services using modern technologies." }
      ],
      stats: [
        { value: "4x", label: "Speed Gain" },
        { value: "97%", label: "Satisfaction Rate" },
        { value: "850+", label: "Systems Built" },
        { value: "99.9%", label: "Reliability" }
      ]
    },
    results: {
      subtitle: "◆ Backend Development Services",
      title: "Results That Improve System Performance and Reliability",
      items: [
        {
          title: "High-Performance Systems",
          desc: "We build fast and efficient systems with our Backend Development Services.",
          metrics: [
            { value: "4x", label: "Faster" },
            { value: "High", label: "Efficiency" }
          ],
          color: "#2563eb"
        },
        {
          title: "Scalable Infrastructure",
          desc: "Our Server Side Development Services ensure your system grows with your business.",
          metrics: [
            { value: "High", label: "Traffic" },
            { value: "Future", label: "Ready" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Secure Backend Systems",
          desc: "Strong security measures when you Hire Backend Developer from our team.",
          metrics: [
            { value: "Data", label: "Protection" },
            { value: "Reliable", label: "APIs" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Build with Backend Development Services?",
      description: "Start with expert Backend Development Services, flexible options to Hire Backend Developer, and reliable Server Side Development Services to power your applications.",
      cta: "Contact Us ↗"
    }
  },
  "WebsiteSpeedOptimizationServices": {
    hero: {
      title: "Website Speed Optimization Services",
      subtitle: "Website Speed Optimization Services to Improve Performance and User Experience",
      description: "Our expert Website Speed Optimization Services help you Improve Website Loading Speed and enhance performance. We implement advanced Core Web Vitals Optimization Service strategies to boost rankings, reduce bounce rates, and deliver a faster user experience.",
      badgeText: "Lightning Fast Performance",
      stats: [
        { value: "1000+", label: "Websites Optimized" },
        { value: "98%", label: "Satisfaction Rate" },
        { value: "3x", label: "Speed Improvement" },
        { value: "90+", label: "Page Speed Score" }
      ]
    },
    services: {
      title: "Complete Website Speed Optimization Services for Better Performance",
      description: "We provide end-to-end Website Speed Optimization Services to improve performance, speed, and user experience.",
      list: [
        {
          title: "Website Speed Audit",
          icon: AssessmentIcon,
          desc: "We analyze your website performance to identify issues affecting loading speed and user experience.",
          features: ["Deep Analysis", "Bottleneck ID", "Speed Reports"]
        },
        {
          title: "Core Web Vitals Optimization Service",
          icon: RocketLaunchIcon,
          desc: "We optimize Core Web Vitals metrics like LCP, CLS, and INP using advanced Core Web Vitals Optimization Service techniques.",
          features: ["LCP & CLS", "INP Optimization", "Google CWV"]
        },
        {
          title: "Performance Optimization",
          icon: SpeedIcon,
          desc: "We optimize images, code, caching, and server response to Improve Website Loading Speed and performance.",
          features: ["Image Comp", "Code Minify", "Caching Setup"]
        }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Website Speed Optimization Process",
      steps: [
        { title: "01 – Performance Analysis", desc: "We analyze your website speed, Core Web Vitals, and performance metrics." },
        { title: "02 – Issue Identification", desc: "We identify bottlenecks affecting Website Speed Optimization Services." },
        { title: "03 – Optimization Implementation", desc: "We apply strategies to Improve Website Loading Speed and enhance performance." },
        { title: "04 – Monitoring & Improvements", desc: "We continuously track performance and refine optimization strategies." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Best Website Speed Optimization Services for Faster Websites",
      reasons: [
        { title: "Performance Experts", desc: "We deliver result-driven Website Speed Optimization Services for all industries." },
        { title: "Advanced Optimization Techniques", desc: "We use proven methods to Improve Website Loading Speed effectively." },
        { title: "Core Web Vitals Expertise", desc: "We specialize in Core Web Vitals Optimization Service to meet Google standards." },
        { title: "Customized Solutions", desc: "Every optimization strategy is tailored to your website needs." }
      ],
      stats: [
        { value: "3x", label: "Speed Gain" },
        { value: "98%", label: "Satisfaction Rate" },
        { value: "90+", label: "Speed Score" },
        { value: "1000+", label: "Successful Audits" }
      ]
    },
    results: {
      subtitle: "◆ Website Speed Optimization Services",
      title: "Measurable Results That Improve Speed and Rankings",
      items: [
        {
          title: "Faster Website Loading Speed",
          desc: "Significant improvements in performance with Website Speed Optimization Services.",
          metrics: [
            { value: "3x Faster", label: "Speed" },
            { value: "Improved", label: "Load Time" },
            { value: "Reduced", label: "Bounce Rate" },
            { value: "Better", label: "Engagement" }
          ],
          color: "#2563eb"
        },
        {
          title: "Improved Core Web Vitals",
          desc: "Better scores with expert Core Web Vitals Optimization Service.",
          metrics: [
            { value: "90+", label: "Score" },
            { value: "Performance", label: "Metrics" },
            { value: "Better UX", label: "User Experience" }
          ],
          color: "#0ea5e9"
        },
        {
          title: "Higher Search Rankings",
          desc: "Faster websites rank better when you Improve Website Loading Speed.",
          metrics: [
            { value: "Top", label: "Rankings" },
            { value: "Keyword", label: "Positions" },
            { value: "Increased", label: "Traffic" },
            { value: "Organic", label: "Growth" }
          ],
          color: "#3b82f6"
        }
      ]
    },
    bottomCTA: {
      title: "Ready to Improve Website Speed and Performance?",
      description: "Start with expert Website Speed Optimization Services, proven methods to Improve Website Loading Speed, and advanced Core Web Vitals Optimization Service for better rankings and user experience.",
      cta: "Contact Us ↗"
    }
  },
  "Digital Marketing": {
    hero: {
      title: "Digital Marketing Services",
      subtitle: "Results-Driven Marketing to Grow Your Digital Presence",
      description: "We provide comprehensive SEO and digital marketing solutions designed to increase visibility, drive targeted traffic, and maximize ROI.",
      badgeText: "SEO & Growth Experts",
      stats: [
        { value: "5000+", label: "Keywords Ranked" },
        { value: "98%", label: "Client Retention" },
        { value: "10x", label: "Average ROI" },
        { value: "Top 3", label: "Organic Reach" }
      ]
    },
    services: {
      title: "Comprehensive SEO & Marketing Solutions",
      description: "Data-driven strategies to dominate search results and capture high-intent leads.",
      list: [
        { title: "ON-Page SEO Services", icon: AssessmentIcon, desc: "Optimize content and structure for maximum search visibility.", features: ["Content Optimization", "Meta Tags", "Internal Linking"] },
        { title: "OFF-Page SEO", icon: SettingsSuggestIcon, desc: "Build authority and credibility through strategic backlinking.", features: ["Link Building", "Brand Mentions", "Outreach"] },
        { title: "Keyword Research Services", icon: QueryStatsIcon, desc: "Identify high-impact keywords that drive qualified traffic.", features: ["Intent Analysis", "Difficulty Audit", "Gap Discovery"] },
        { title: "SEO Consultant Services", icon: SupportAgentIcon, desc: "Expert strategic guidance to scale your organic growth.", features: ["Strategy Audits", "Growth Roadmaps", "Market Analysis"] }
      ]
    },
    process: {
      subtitle: "◆ Our Process",
      title: "Strategy. Implementation. Growth.",
      steps: [
        { title: "Discovery", desc: "Understanding your market and audience." },
        { title: "Planning", desc: "Creating a data-backed SEO roadmap." },
        { title: "Execution", desc: "Implementing technical and content fixes." },
        { title: "Analysis", desc: "Measuring impact and refining tactics." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "The Vihaan Innovations SEO Advantage",
      reasons: [
        { title: "Proven Track Record", desc: "We consistently deliver Top 3 rankings for competitive keywords." },
        { title: "Holistic Approach", desc: "We combine technical, on-page, and strategic SEO for better results." },
        { title: "Real-Time Reporting", desc: "Full transparency into your campaign performance and ROI." },
        { title: "Continuous Innovation", desc: "We adapt to every search engine algorithm update instantly." }
      ],
      stats: [
        { value: "10x", label: "ROI for Clients" },
        { value: "98%", label: "Satisfaction" },
        { value: "50k+", label: "Leads Generated" },
        { value: "Top 3", label: "Ranking Success" }
      ]
    },
    bottomCTA: {
      title: "Ready to Dominate Search Results?",
      description: "Start your journey to organic growth with our expert SEO and marketing solutions tailored for your business.",
      cta: "Contact Us ↗"
    }
  },
  "Services Development": {
    hero: {
      title: "Web Design & Development",
      subtitle: "Modern Digital Products Built for Performance and Scale",
      description: "From stunning visual designs to robust backend architectures, we build high-performance web solutions that drive business success.",
      badgeText: "Enterprise Grade Development",
      stats: [
        { value: "800+", label: "Websites Built" },
        { value: "100%", label: "Code Ownership" },
        { value: "4x", label: "Faster Market Speed" },
        { value: "99.9%", label: "System Uptime" }
      ]
    },
    services: {
      title: "End-to-End Web Solutions",
      description: "Integrated design and development services for modern businesses.",
      list: [
        { title: "Website Design Services", icon: BrushIcon, desc: "Visually stunning, user-centric designs that capture your brand essence.", features: ["UI/UX Design", "Custom Layouts", "Responsive Design"] },
        { title: "Frontend Development Services", icon: CodeIcon, desc: "Fast, interactive, and responsive user interfaces with modern frameworks.", features: ["React/Next.js", "Pixel Perfect", "Fluid Motion"] },
        { title: "Backend Development Services", icon: StorageIcon, desc: "Secure, scalable server-side systems that power your business logic.", features: ["Node.js/APIs", "DB Architectures", "Scalable Systems"] },
        { title: "Website Speed Optimization Services", icon: SpeedIcon, desc: "Lightning-fast performance that satisfies users and search engines.", features: ["Core Web Vitals", "Asset Caching", "DB Tuning"] }
      ]
    },
    process: {
      subtitle: "◆ How It Works",
      title: "Our Development Lifecycle",
      steps: [
        { title: "Prototyping", desc: "Visualizing the user experience and flows." },
        { title: "Sprints", desc: "Agile development with regular feedback loops." },
        { title: "Optimization", desc: "Refining performance and technical SEO." },
        { title: "Deployment", desc: "Safe, zero-downtime launches." }
      ]
    },
    comparison: {
      subtitle: "◆ Why Choose Us",
      title: "Engineering Excellence at Every Layer",
      reasons: [
        { title: "Full-Stack Mastery", desc: "Expertise in both visual design and heavy backend engineering." },
        { title: "Scalable by Design", desc: "Every line of code is written with future growth in mind." },
        { title: "Security First", desc: "Enterprise-grade security protocols for all data and logic." },
        { title: "Speed Obsessed", desc: "We ensure minimum 90+ Lighthouse scores for every project." }
      ],
      stats: [
        { value: "4x", label: "Faster Delivery" },
        { value: "99.9%", label: "Uptime Guaranteed" },
        { value: "800+", label: "Products Launched" },
        { value: "90+", label: "Min Speed Score" }
      ]
    },
    bottomCTA: {
      title: "Build Your Next Big Idea With Us",
      description: "Get a free technical consultation for your web design or custom development project today.",
      cta: "Schedule a Call ↗"
    }
  }
};

export const getExploreDataByTitle = (title) => {
  if (!title) return null;

  // 1. Try exact match
  if (exploreServiceData[title]) return exploreServiceData[title];

  const query = title.toLowerCase().replace(/[\s-]/g, "");

  // 2. Try strict normalized match (no partial includes)
  const matchingKey = Object.keys(exploreServiceData).find(k => {
    const normalizedKey = k.toLowerCase().replace(/[\s-]/g, "");
    return normalizedKey === query;
  });

  if (matchingKey) return exploreServiceData[matchingKey];

  return null;
};
